var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCerrar = function SvgCerrar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "cerrar_svg__Capa_2",
    viewBox: "0 0 26 25.99"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cerrar_svg__Capa_1-2",
    d: "M21.57 3.22c-4.87-4.29-12.28-4.29-17.15 0-5.9 5.19-5.9 14.37 0 19.55 4.87 4.29 12.28 4.29 17.15 0 5.9-5.19 5.9-14.37 0-19.55m-3.01 13.92a.996.996 0 0 1-.71 1.7c-.26 0-.51-.1-.71-.29l-4.15-4.15-4.15 4.15c-.2.2-.45.29-.71.29s-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l4.15-4.15-4.15-4.15a.996.996 0 1 1 1.41-1.41l4.15 4.15 4.15-4.15a.996.996 0 1 1 1.41 1.41l-4.15 4.15 4.15 4.15Z",
    fill: "#ff4772"
  })));
};
export default SvgCerrar;